import React, {useEffect} from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { Grid } from "@mui/material";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import { resetFormStep } from "../../../Actions";

const FormCompletionSuccess = () => {
  const globalDispatch = useDispatch();

  useEffect(() => {
    const element = document.getElementById("treg-container");
    element.scrollIntoView({ behavior: "smooth" });
  }, [])

  return (
    <Grid
      container
      style={{
        border: "1px solid lightgrey",
        borderRadius: "7px",
        padding: "2rem 1rem",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignItems: "center",
      }}
      gap={"3rem"}
    >
      <Grid
        item
        xs
        style={{
          display: "flex",
          backgrounColor: "red",
        }}
      >
        <ThumbUpAltIcon color='success' sx={{ fontSize: 40 }} />
      </Grid>

      <Grid item xs>
        <h2> Registration Completed Successfully! </h2>
      </Grid>

      <Grid item xs style={{ width: "31rem", marginTop: "-1.7rem"}}>
        <p style={{
          fontSize: "smaller",
          color: "#757575",
          textAlign: "center"
        }}>
          Congratulations on completing your registration! NYSC officials will
          review your application for potential approval or disapproval as the
          case may be.
        </p>
      </Grid>

      <Grid item xs onClick={() => globalDispatch(resetFormStep())}>
        <Link to={'/'}>
          <p style={{
            color: "#666666",
            textDecoration: "underline",
            fontSize: "small"
          }}>
            Go to Landing Page
          </p>
        </Link>
      </Grid>
    </Grid>
  );
};

export default FormCompletionSuccess;
